module.exports = (__webpack_require__("49fU"))(244);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-router/es/index.js from dll-reference vendor_library
// module id = CIox
// module chunks = 23